import type { PadronHealthCheck } from '../../api/types';

export interface PadronStatusView {
  label: string;
  tone: 'approved' | 'rejected' | 'draft';
  detail?: string;
}

// Traduce el health check del padrón a un estado legible. El padrón no condiciona la emisión: ningún estado
// bloquea el onboarding.
export function padronStatusView(check: PadronHealthCheck | null, failed: boolean): PadronStatusView {
  if (failed) return { label: 'no disponible', tone: 'rejected', detail: 'No se pudo consultar el estado.' };
  if (!check) return { label: 'consultando…', tone: 'draft' };
  if (!check.credential.configured) {
    return {
      label: 'no configurada',
      tone: 'draft',
      detail: 'La plataforma todavía no tiene habilitada la consulta al padrón.',
    };
  }
  if (check.service.available && check.credential.ready) return { label: 'activa', tone: 'approved' };
  if (!check.service.available) {
    return { label: 'no disponible', tone: 'rejected', detail: 'El servicio de padrón de ARCA no está disponible en este momento.' };
  }
  return { label: 'no disponible', tone: 'rejected', detail: 'La credencial de la plataforma no está lista.' };
}

export function PadronStatus({ check, failed }: { check: PadronHealthCheck | null; failed: boolean }) {
  const view = padronStatusView(check, failed);
  return (
    <div className="padron-status">
      <div className="row">
        <span>Verificación de padrón ARCA:</span>
        <span className={`badge ${view.tone}`}>{view.label}</span>
        {view.detail && <span className="muted">{view.detail}</span>}
      </div>
      <p className="muted padron-note">
        Sirve para verificar la condición de IVA de tus clientes. No es necesaria para facturar.
      </p>
    </div>
  );
}
